import { FC } from 'react';
import styled from 'styled-components';

interface IProps {
  className?: string;
  checked: boolean;
  onChange?: (param: any) => void;
  onClickCapture?: (e: any) => void;
  text: string | null;
  disabled?: boolean;
}

const Block = styled.label`
  input {
    position: relative;
    top: 0px;
  }

  .mr5p {
    margin-right: 5px;
  }
`;

const Checkbox: FC<IProps> = ({
  className, checked, onChange, onClickCapture, text, disabled,
}) => {
  return (
    <Block className="form-check-label pointer">
      <input
        type="checkbox"
        className={'pointer ' + (text ? 'mr5p ' : '') + (className ? className : '')}
        checked={checked}
        onChange={onChange}
        onClickCapture={onClickCapture}
        disabled={disabled}
      />
      {text}
    </Block>
  )
}

export default Checkbox;
